import React from 'react';
import config from '../../../../config';
import { Button, Checkbox, Col, FormControl, Row } from 'react-bootstrap';
import _ from 'lodash';
import { allFeesList } from 'dashboard/processing/PostingSharedMethods';
import classNames from 'classnames';
import Toggle from 'react-bootstrap-toggle';
import { base64ToHex } from 'util/Utils';

export function FeesScreen(props) {
  const {
    overrideShippingStatus,
    Shippable = false,
    Condition,
    GBGProductFound,
    ProductCategories = [],
    selectedGBGProduct = {},
    HotBuy,
    InternalComment,
    productCustomData = {},
    selectedCategories = [],
    currentServiceRecord = {},
  } = props.screensData;
  const { GBGProductTags = [], Categories = [] } = selectedGBGProduct;
  const donationCategory = ProductCategories.find((item) => {
    return item.Category == 'Donate' || item.Subcategory == 'Donate';
  });
  let feesToRender = _.cloneDeep(allFeesList);

  const isCarseat =
    Categories.find((item) => item.Category.toLowerCase() == 'carseat') ||
    selectedCategories.find((item) => item.TagName.toLowerCase() == 'carseat'); /* when pre-listing is created */
  if (props.appData.FeatureFlags.EnableCarSeatsProcessing && currentServiceRecord.HasUsedCarSeat && isCarseat) {
    feesToRender.push({
      feeType: 'PrintCarSeatManual',
      label: 'Printing Car Seat Manual Fee',
      additionalLabel: ': $5',
    });
  }

  const shippableSwitcherFixed =
    _.intersection(GBGProductTags, ['Shipping Options_Notshippable', 'Shipping Options_Shippable']).length > 0;
  const conditionLoved = config.conditionsData.find((item) => item.value == 'Loved');
  return (
    <Row className="screen-content">
      <Col xs={6} className="text-center align-center">
        <div className="screen_title"> A few more optional questions</div>

        {Condition !== conditionLoved['number'] && !GBGProductFound && !donationCategory && (
          <div className="top20 text-left ">
            <Checkbox
              data-testid="hot-buy-checkbox"
              onChange={() => {
                props.setScreensData({ HotBuy: !HotBuy });
              }}
              data-testid="hot-buy-checkbox"
              checked={HotBuy}
            >
              <span className="text-bold">Hot Buy</span>
            </Checkbox>
          </div>
        )}
        {!donationCategory && (
          <div>
            <div className="text-bold font-size-17 bot5 top20 text-left">Fees</div>
            {props.renderFeeList(feesToRender)}
          </div>
        )}

        {!donationCategory && (
          <div className="top20 text-left ">
            <span
              data-testid="shippable-toggle-label"
              style={{
                position: 'relative',
                top: '-2px',
              }}
              onClick={() => {
                if (!overrideShippingStatus && shippableSwitcherFixed) {
                  return;
                }

                props.setScreensData({ Shippable: !Shippable });
              }}
              className={classNames('text-bold font-size-17 right15  text-left', {
                'cursor-pointer': overrideShippingStatus || !shippableSwitcherFixed,
              })}
            >
              Shippable
            </span>
            <Toggle
              disabled={!overrideShippingStatus && shippableSwitcherFixed}
              onClick={(option) => {
                props.setScreensData({ Shippable: option });
              }}
              style={
                Shippable == 'not_specified'
                  ? { width: 100, height: 30, backgroundColor: '#ddd', borderColor: '#ddd' }
                  : { width: 100, height: 30 }
              }
              on={'Yes'}
              off={Shippable == 'not_specified' ? 'Not set' : 'No'}
              onClassName={'selected-state'}
              offClassName={Shippable == 'not_specified' ? 'indeterminate-state' : ''}
              offstyle={'danger'}
              active={Shippable == 'not_specified' ? false : Shippable}
            />

            {config.checkAccessRights.call(
              {},
              { userData: props.userReducer.user, resources: ['problem_solver_access'] }
            ) &&
              shippableSwitcherFixed && (
                <Checkbox
                  onChange={() => {
                    props.setScreensData({ overrideShippingStatus: !overrideShippingStatus });
                  }}
                  data-testid="override-shipping-options-checkbox"
                  checked={overrideShippingStatus}
                >
                  {' '}
                  Override Shipping Status
                </Checkbox>
              )}
          </div>
        )}
        {('priceCheckPrelisting' == productCustomData.currentProductAction || !selectedGBGProduct._id) &&
          !donationCategory && (
            <div className="top20">
              <div className="text-bold font-size-17 bot5 top20 text-left">Internal Comment</div>
              <FormControl
                rows="5"
                componentClass="textarea"
                data-testid="internal-comment-text-input"
                style={{
                  borderRadius: 5,
                  borderWidth: 1,
                  height: 70,
                  backgroundColor: '#FCF8CB',
                  borderColor: '#c9c9c9',
                }}
                value={InternalComment}
                onChange={({ target: { value } }) => {
                  props.setScreensData({ InternalComment: value });
                }}
                placeholder=" "
              />
            </div>
          )}

        <div className="top30 text-center ">
          <Button
            data-testid="next-screen-button"
            disabled={props.pending}
            className="btn btn-lg btn-primary set-width "
            onClick={() => {
              onSubmitHandler(props, { donationCategory });
            }}
          >
            Continue
          </Button>
        </div>
      </Col>
    </Row>
  );
}

function onSubmitHandler(props, params) {
  const {
    overrideShippingStatus,
    FeesToAdd = [],
    Shippable = false,
    InternalComment,
    productAction = {},
  } = props.screensData;

  if (props.pending) {
    return;
  }

  props.updateParentComponentState({ pending: true });

  let dataToSave = {};

  if (overrideShippingStatus) {
    dataToSave.OverrideShippable = true;
  }

  dataToSave.FeesToAdd = [];

  if (!params.donationCategory) {
    if (FeesToAdd.length) {
      dataToSave['FeesToAdd'] = FeesToAdd.map((fee) => {
        let feeData = { feeType: fee.feeType };

        if (!_.isUndefined(fee.amount)) {
          feeData.amount = fee.amount;
        }

        return feeData;
      });
    }
  }

  const firstImage = props.images && props.images[0] ? props.images[0] : {};

  if (InternalComment) {
    dataToSave.Comments = [
      {
        CommentText: InternalComment,
        CommentImageURL: firstImage.s3FileURL,
        SentByUserID: base64ToHex(props.userReducer.user._id),
        SentByUserName: `${props.userReducer.user.firstName}${
          props.userReducer.user.lastName ? ` ${props.userReducer.user.lastName}` : ''
        } `,
      },
    ];
  }

  if (productAction == 'AddPrelisting') {
    dataToSave.Shippable = Shippable;

    if (!params.donationCategory) {
      if (Shippable == 'not_specified') {
        props.displayMessage({
          messageType: 'warning',
          messageCode: 'Please, specify if product is shippable',
        });
        props.updateParentComponentState({ pending: false });
        return false;
      }
    } else {
      dataToSave.Shippable = false;
      dataToSave.FeesToAdd = [];
    }
  }

  props.goToNextScreenCallback(dataToSave);
}
